import type { Session, User } from '@supabase/supabase-js'
import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabaseClient'

export type AuthState = {
  isLoading: boolean
  isLoggedIn: boolean
  user: User | null
  session: Session | null
  isConfigured: boolean
}

export function useAuth(): AuthState {
  const isConfigured = Boolean(supabase)
  const [isLoading, setIsLoading] = useState(() => isConfigured)
  const [session, setSession] = useState<Session | null>(() => null)

  useEffect(() => {
    if (!supabase) return
    let mounted = true

    void supabase.auth.getSession().then(({ data, error }) => {
      if (!mounted) return
      if (error) {
        setSession(null)
      } else {
        setSession(data.session ?? null)
      }
      setIsLoading(false)
    })

    const { data: sub } = supabase.auth.onAuthStateChange((_event, nextSession) => {
      if (!mounted) return
      setSession(nextSession)
      setIsLoading(false)
    })

    return () => {
      mounted = false
      sub.subscription.unsubscribe()
    }
  }, [])

  return {
    isLoading,
    isLoggedIn: Boolean(session),
    user: session?.user ?? null,
    session,
    isConfigured,
  }
}

